import Head from 'next/head'
import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'

function MetaData({ children }: { children?: React.ReactNode }) {
  const { t } = useTranslation()
  const [title, setTitle] = useState(t('General.MetaData.General.Title'))

  useEffect(() => {
    // Function to update the title
    const updateTitle = (newTitle: string) => {
      setTitle(newTitle)
    }

    // Listen for custom events to update the title
    window.addEventListener('updateTitle', ((event: CustomEvent) => {
      updateTitle(event.detail.title)
    }) as EventListener)

    return () => {
      window.removeEventListener('updateTitle', ((event: CustomEvent) => {
        updateTitle(event.detail.title)
      }) as EventListener)
    }
  }, [])


  return (
    <Head>
      <title>{title}</title>
      <meta name="robots" content="noindex" />
      <meta name="description" content={t('General.MetaData.General.Description')} key="desc" />
      <meta property="og:title" name="og:title" content={t('General.MetaData.General.Title')} />
      <meta property="og:description" name="og:description" content={t('General.MetaData.General.Description')} />
      <meta
        property="og:image"
        name="og:image"
        content="https://onthatass.com/images/design/heroes/campaign/heroes-men-originals-mob.webp"
      />
      {children}
    </Head>
  )
}

export default MetaData
